import { TSaveBtnStatus } from '../../types/common/saveBtn.type';

const SAVE_BTN_STATUS: TSaveBtnStatus = {
	PUBLISH: 'Publish',
	SAVE: 'Save',
	SAVING: 'Saving',
	SAVED: 'Saved',
};

export default SAVE_BTN_STATUS;
